import { axiosInstance } from './axiosConfig';

export function forgotPassword(forgotPasswordData) {
  return axiosInstance
    .post('authentication/forgotPassword', forgotPasswordData)
    .then((response) => response.data)
    .catch((error) => error.response.data);
}
